import React from 'react'

const StudentsProgressReport = () => {
  return (
    <div>
      
    </div>
  )
}

export default StudentsProgressReport
